export default "__VITE_ASSET__BJwy1tGg__"